// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import './Label.less';

/**
 * Label component.
 */
const Label = ({ baseClassName, className, intent, children, ...props }) => (
    <span className={classNames(baseClassName, intent && `${baseClassName}--${intent}`, className)} {...props}>
        {children}
    </span>
);

Label.propTypes = {
    /**
     * Content of the Label
     */
    children: PropTypes.any,
    /**
     * Intent of the Label
     */
    intent: PropTypes.oneOf(['inactive', 'success', 'warning', 'danger', 'info']),
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
Label.defaultProps = {
    children: null,
    intent: null,
    className: null,
    baseClassName: `${CLS_PREFIX}label`,
};

export default Label;



// WEBPACK FOOTER //
// ./components/Label/Label.js